import { LogEntry } from '@timechef/core/logging/log-entry';
import { Observable } from 'rxjs';
import { LoggerConfig, LogLevel } from 'src/environments/environment-config';

export abstract class Sink {
  abstract log(record: LogEntry): Observable<void>;
  constructor(public config: LoggerConfig) {
    if (!config) {
      console.error('Bad config');
      this.config = { isActive: true, logLevel: LogLevel.Debug };
    }
  }
}
